export const reportClientError = (...data: unknown[]): void => {
  // eslint-disable-next-line no-console
  console.error(...data);
};
